import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchBlogPost } from "@/lib/api";
import { ArrowLeft } from "@phosphor-icons/react";
import CTASection from "@/components/CTASection";

export default function BlogPost() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);

    useEffect(() => {
        fetchBlogPost(slug)
            .then((p) => {
                setPost(p);
                document.title = `Surveys2CAD | ${p.title}`;
            })
            .catch(() => setPost(null));
    }, [slug]);

    if (!post) {
        return <div className="max-w-3xl mx-auto px-5 py-24 text-center text-slate-400">Loading…</div>;
    }

    return (
        <div className="max-w-3xl mx-auto px-5 lg:px-8 py-16 md:py-24" data-testid="blog-post-detail">
            <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-300 mb-8">
                <ArrowLeft size={16} /> All articles
            </Link>
            <div className="flex items-center gap-3 mb-4 text-xs text-slate-500 font-mono-alt">
                <span className="text-cyan-400">{post.category}</span>
                <span className="dot-divider" />
                <span>{new Date(post.date).toLocaleDateString()}</span>
                <span className="dot-divider" />
                <span>{post.read_time} read</span>
            </div>
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-slate-50 tracking-tighter leading-[1.1] mb-6">
                {post.title}
            </h1>
            <p className="text-xl text-slate-400 leading-relaxed">{post.excerpt}</p>
            <article className="prose prose-invert mt-12 max-w-none text-slate-300 leading-relaxed space-y-5">
                <p>
                    This is a preview of our upcoming long-form article. The full breakdown — with step-by-step CAD
                    workflows, spec references, and downloadable drafting checklists — lands in your inbox when you
                    subscribe below.
                </p>
                <p>
                    Our team has delivered over 330,000 drawings to licensed surveyors and engineering firms across the
                    Northern US. Every article on this blog distills a hard-won lesson from production drafting at scale.
                </p>
                <p className="text-slate-400 italic">Full content launching soon — subscribe to the newsletter to get notified.</p>
            </article>
            <div className="mt-16">
                <CTASection title="Ready to put these practices to work on your next project?" />
            </div>
        </div>
    );
}
